(function($) {
    'use strict';

    $(function() {
        function autosize() {
            var el = this;
            setTimeout(function() {
                el.style.cssText = 'height:auto; padding:0';
                // for box-sizing other than "content-box" use:
                // el.style.cssText = '-moz-box-sizing:content-box';
                el.style.cssText = 'height:' + parseInt(el.scrollHeight + 12, 10) + 'px';
            }, 0);
        }

        if (document.getElementById('cl_msg_txtarea')) {
            document.getElementById('cl_msg_txtarea').addEventListener('keydown', autosize);
        }

        $('.contact_form').parsley({
            trigger: 'change',
            successClass: 'is-success',
            errorClass: 'is-error',
            classHandler(el) {
                return el.$element.closest('.form-group');
            },
            errorsWrapper: '<div class="invalid-message error-text"></div>',
            errorTemplate: '<span></span>'
        });

        let is_submitting = false;

        $('.contact_form').on('submit', function(e) {
            if (is_submitting) {
                return false;
            }

            is_submitting = true;
            $('.contact_form__btn').prop('disabled', true);

            e.preventDefault();

            const $this = $(this);

            // JS validation/Parsley.js

            const formdata = $this.serializeArray();

            $.ajax({
                url: ajax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'handle_contact_form',
                    datas: formdata
                },
                success: function(response) {
                    is_submitting = false;
                    const result = JSON.parse(response);
                    swal({
                        title: result.title,
                        text: result.message,
                        icon: result.icon,
                        button: 'ok'
                    });
                },
                error: function(response) {
                    is_submitting = false;
                }
            }).done(function(response) {
                $('.contact_form__btn').prop('disabled', false);
            });
        });
    });
})(jQuery);
